import * as Sentry from "@sentry/remix";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";


Sentry.init({
  dsn: "https://fdc3b7353fc63bc9f07d934c1febc6a3@o4504632664719360.ingest.us.sentry.io/4508657644142592",
  tracesSampleRate: 1,
  debug: false,
  integrations: [Sentry.browserTracingIntegration({
    useEffect,
    useLocation,
    useMatches
  })]
})


startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});